'use client';

import { useEffect } from 'react';
import { hasAuthenticated } from '@/app/utils/authentication';

// Sends a pageview event to the tracker once, when the component mounts.
export default function RedirectReturningUser() {
  useEffect(() => {
    if (hasAuthenticated()) {
      window.location.href = '/journals';
    }
  }, []);
  return null;
}
